module.exports = __webpack_public_path__ + "static/title-product.2ffbc6d9.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/title-product.png
// module id = 315
// module chunks = 2